/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
const t=t=>{if(null==t||"object"!=typeof t)return[];return[..."templates"in t&&Array.isArray(t.templates)?t.templates:[],..."types"in t&&Array.isArray(t.types)?t.types.flatMap((t=>t.templates)):[]]};export{t as getAllTemplatesForLayer};
